module.exports = __webpack_public_path__ + "img/learn.5101805.svg";